import { Card, Divider, Typography } from '@healthinal/ui';
import { EditTuberculosisHistoryForm } from './EditTuberculosisHistoryForm.tsx';

export function TuberculosisHistoryCard({ tracingContactId }: { tracingContactId: string }) {
  return (
    <Card>
      <Typography level={'title-lg'}>Krankengeschichte</Typography>
      <Divider />
      <EditTuberculosisHistoryForm tracingContactId={tracingContactId} />
    </Card>
  );
}
